<ng-container *ngIf="!realImage">
  <loader *ngIf="showLoader && !!src"></loader>
  <div *ngIf="!!src" [ngClass]="{ contain: isContain, auto: isAuto }" class="ibex-img {{id}}"></div>
  <div *ngIf="!src" class="placeholder">
    <div [style.background-image]="'url(' + placeholder + ')'" class="placeholder-image"></div>
    <div class="placeholder-overlay"></div>
  </div>
</ng-container>
<ng-container *ngIf="!!realImage">
  <img [src]="backgroundImage" [id]="id"/>
</ng-container>
<div *ngIf="showFileTitle && titles && (forceShowTitle || (!size || !notTitleSizes.includes(size)))" class="image-title {{id + '-title'}}" [style.right]="!realImage ? '10px' : 'none'">
  {{titles[lang] ? titles[lang] : titles?.de}}
</div>
